/*
 I ruoli applicativi, con i numeri con cui il backend li tiene (enum `Roles`).

 A decidere chi può fare cosa è sempre il backend, dentro i service: qui i ruoli servono a non
 mostrare un comando che verrebbe poi rifiutato, che è una cosa diversa da una protezione. Un
 pulsante nascosto non difende nulla, e un pulsante che compare e poi fallisce è un difetto di
 interfaccia: servono entrambi i controlli, ciascuno al suo posto.
*/
export const Role = {
  SUPERADMIN: 1,
  APPROVATORE: 2,
  RICHIEDENTE: 3,
  DIPENDENTE: 4,
  ADMIN: 5,
} as const;

/*
 Chi può eliminare un dipendente dall'anagrafica: gli stessi ruoli amministrativi che possono
 registrare utenti. Rispecchia il controllo in `EmployeeService.delete`, e va tenuto allineato
 a quello.
*/
export function puoEliminareDipendenti(role: number | undefined): boolean {
  return role === Role.SUPERADMIN || role === Role.ADMIN;
}

/*
 Chi può modificare il profilo aziendale, le sedi e le utenze della pagina `/user`: gli stessi
 ruoli amministrativi. Rispecchia `CompanyService.verificaGestoreAzienda` (per
 `POST /company/editByUser`) e `UserService.verificaGestore` (per `PUT /user/update`,
 `POST /user/registration` e `DELETE /user`) del backend, e va tenuto allineato a quelli: agli
 altri ruoli la pagina resta consultabile, ma un «Salva» mostrato a loro finirebbe in un 403.

 DVR e organigramma non passano da qui: chi può caricarli ed eliminarli non è ancora deciso.
*/
export function puoGestireAzienda(role: number | undefined): boolean {
  return role === Role.SUPERADMIN || role === Role.ADMIN;
}

/*
 Chi può caricare ed eliminare il manuale della piattaforma: solo il SUPERADMIN. Il manuale è uno
 per tutta la piattaforma, non un documento dell'azienda, e l'ADMIN non lo gestisce. Rispecchia
 `CompanyService.savePlatformManual` (per `PATCH /company?docType=manual`) e
 `CompanyService.deletePlatformManual` (per `DELETE /company/manual`) del backend, che agli altri
 ruoli rispondono 403: va tenuto allineato a quelli.
*/
export function puoGestireManuale(role: number | undefined): boolean {
  return role === Role.SUPERADMIN;
}

/*
 Chi può scaricare il manuale della piattaforma: ADMIN e SUPERADMIN. Rispecchia
 `CompanyService.getPlatformManual` (per `GET /company/manual`), che agli altri ruoli risponde
 403. Il nome del file (`GET /company/manual-name`) invece lo legge chiunque sia autenticato,
 per questo la pagina lo mostra a tutti.
*/
export function puoScaricareManuale(role: number | undefined): boolean {
  return role === Role.SUPERADMIN || role === Role.ADMIN;
}
